import React, { useEffect, useState, useRef } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import {
  Avatar,
  Button,
  Divider,
  Grid, 
  Link,
  Typography,
} from '@material-ui/core'
import { CheckCircleRounded, Warning } from "@material-ui/icons";
import CircleContent from '../../../common/components/CustomComponents/CircleContent'
import Alert from '@material-ui/lab/Alert'
import Skeleton from '@material-ui/lab/Skeleton'
import Validator from 'validatorjs'
import {
  DIALOG_STATE_INIT,
  errorsInitState,
  COUNTRY_SECTION_NAME,
  DOCUMENT_NUMBER_CLEAN_REGEX,
  HEAR_ABOUT_US_SECTION_NAME,
  SHOP_FORM_SECTION_NAME,
  VENDOR_FORM_SECTION_NAME,
  SVC_LOGIN_URL,
  CHILE,
  PERU,
  OTHER_MARKETS_SECTION_NAME,
  WARNING_DEPARTMENT,
  DEPARTMENTS_WITH_OPL
} from '../../../../constants'
import { ConfirmationDialog } from '../../../common/components/Dialog'
import { onPostRegistry } from '../../model'
import Settings from '../../../../services/Settings'
import AboutRegistry from '../AboutRegistry/AboutRegistry'
import MarketsForm from '../MarketsForm/MarketsForm'
import ShopForm from '../ShopForm/ShopForm'
import VendorForm from '../VendorForm/VendorForm'
import validationRules from '../../../../utils/validationRules/validationRules'
import errorMessages from '../../../../utils/errorMessages/errorMessages'
import { OnboardingDataFormJss } from './styleJss'

const OnboardingDataForm = ({onBoardingDataInitState}) => {
  const classes = OnboardingDataFormJss()
  const [token, setToken] = useState('')
  const [state, setState] = useState(onBoardingDataInitState)
  const [checkedCaptcha, setCheckedCaptcha] = useState(false)
  const [sendButtonEnabled, setSendButtonEnabled] = useState(false)
  const [dialogState, setDialogState] = useState(DIALOG_STATE_INIT)
  const handleSetDialogState = () => window.location.reload(false)
  const handleSetDialogStateError = () => {
    setDialogState(DIALOG_STATE_INIT)
    recaptchaRef.current.reset()
  }
  const [errors, setErrors] = useState(errorsInitState)
  const recaptchaRef = useRef()

  const dialogOnSuccess = () =>
    setDialogState({
      title: (
        <div>
          <Typography variant='h3'>Formulario completado</Typography>
        </div>
      ),
      type: 'primary',
      open: true,
      buttonLabels: {
        onCloseLabel: 'Cancelar',
        onSuccessLabel: 'Ir a Seller Center'
      },
      actions: {
        onClose: handleSetDialogState,
        onSuccess: () => {
          window.open(SVC_LOGIN_URL, '_blank')
        }
      },
      maxWidth: 'sm',
      children: (
        <div className={classes.dialogBody}>
          <Typography variant='h4'>
            Te hemos enviado un correo para que termines de completar los datos de tu tienda
            y seas parte del Marketplace de Ripley.com&nbsp;
          </Typography>
          <Grid container direction="column" justifyContent="center" alignItems="center" spacing={1} className={classes.list}>
              <Grid item container xs={12} direction="row" alignItems="center" justifyContent="center" >
                <Grid item xs={2}>
                  <Avatar className={classes.iconContainer}>
                    <CheckCircleRounded color='inherit'/>
                  </Avatar>
                </Grid>   
                <Grid item xs={1}>
                  <Divider className={classes.dividerFirst}/>
                </Grid>
                <Grid item xs={2}>
                  <Avatar >
                    <CircleContent text='2' />
                  </Avatar>
                </Grid>
                <Grid item xs={1}>
                  <Divider className={classes.divider}/>
                </Grid>
                <Grid item xs={2}>
                  <Avatar>
                    <CircleContent text='3' />
                  </Avatar>
                </Grid>
                <Grid item xs={1}>
                  <Divider className={classes.divider}/>
                </Grid>
                <Grid item xs={2}>
                  <Avatar>
                    <CircleContent text='4' />
                  </Avatar>
                </Grid>
              </Grid>
              <Grid item container xs={12} direction="row" alignItems="flex-start" justifyContent="space-between" >
                <Grid item xs={3}>
                  <Typography className={classes.listItemTextRegular}>
                    Formulario
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography className={classes.listItemTextRegular}>
                    Completa los datos de tu tienda
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography className={classes.listItemTextRegular}>
                    Espera a que validemos la informacion
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography className={classes.listItemTextRegular}>
                    Eres parte del Marketplace Ripley.com !
                  </Typography>
                </Grid>
              </Grid>
          </Grid>
        </div>
      ),
      hasSecondaryButton: true
    })

  const dialogOnPending = () =>
    setDialogState({
      title: <></>,
      type: 'primary',
      open: true,
      buttonLabels: {
        onCloseLabel: '',
        onSuccessLabel: 'Enviando'
      },
      actions: {
        onClose: () => handleSetDialogState,
        onSuccess: () => handleSetDialogState
      },
      children: (
        <div className={classes.dialogBody}>
          <Skeleton variant='rect' width={320} height={118} />
        </div>
      ),
      hasSecondaryButton: false
    })

  const dialogOnError = (response) => {
    let dialogTitle = 'Ha ocurrido un error'
    let dialogBodyText = 'Vuelve a intentarlo nuevamente'
    let bodyTypography = <Typography variant='h4'>{dialogBodyText}</Typography>
    if (response.status === 409) {
      dialogTitle = 'Ya te habías registrado'
      dialogBodyText =
        'En minutos recibirás un correo con los accesos para ingresar al sitio para vendedores Mercado Ripley.com '
      bodyTypography = (
        <Typography variant='h4'>
          {dialogBodyText}
          <Link href={SVC_LOGIN_URL} onClick={(e) => e.preventDefault}>
            Seller Center
          </Link>
        </Typography>
      )
    }
    setDialogState({
      title: (
        <div>
          <Typography variant='h3'>{dialogTitle}</Typography>
        </div>
      ),
      type: 'primary',
      open: true,
      buttonLabels: {
        onCloseLabel: '',
        onSuccessLabel: 'Cerrar'
      },
      actions: {
        onClose: handleSetDialogStateError,
        onSuccess: handleSetDialogStateError
      },
      children: <div className={classes.dialogBody}>{bodyTypography}</div>,
      hasSecondaryButton: false
    })
  }

  const onHandleErrors = (newErrors) => {
    setErrors(newErrors)
  }

  const handleSendError = (response) => {
    dialogOnError(response)
    if (response.status === 422) {
      if (response.data.data === undefined) {
        return
      }
      const responseErrorBody = JSON.parse(response.data.data)
      const mappedErrors = { ...errors }
      for (const key in responseErrorBody) {
        /* Only the first error */
        const keyValue = responseErrorBody[key][0]
        const keyParts = key.split('.')
        const keySectionName = keyParts[0]
        const keySectionFieldName = keyParts[1]
        let sectionName
        if (
          keySectionName.includes('store_information') ||
          keySectionName.includes('about_store')
        ) {
          sectionName = SHOP_FORM_SECTION_NAME
        } else if (
          keySectionName.includes('seller_information') &&
          keySectionFieldName === 'country'
        ) {
          sectionName = COUNTRY_SECTION_NAME
        } else if (keySectionName.includes('seller_information')) {
          sectionName = VENDOR_FORM_SECTION_NAME
        } else if (keySectionName.includes('hear_about_us')) {
          sectionName = HEAR_ABOUT_US_SECTION_NAME
        }
        mappedErrors[sectionName][keySectionFieldName] = keyValue
      }
      setErrors(mappedErrors)
    }
  }

  const onHandleSendData = () => {
    const data = state
    const cleanDocNumberRegex = DOCUMENT_NUMBER_CLEAN_REGEX[data.country]
    const otherMarkets = data[OTHER_MARKETS_SECTION_NAME].other_markets_added===''
    ? data[OTHER_MARKETS_SECTION_NAME].other_markets.split(',') : 
    (data[OTHER_MARKETS_SECTION_NAME].other_markets_added+','+data[OTHER_MARKETS_SECTION_NAME].other_markets).split(',')

    const mappedData = {
      about_store: {
        main_category: data[SHOP_FORM_SECTION_NAME].main_category,
        dte_emit: data[SHOP_FORM_SECTION_NAME].dte_emit.toLowerCase(),
        hear_about_us: data[HEAR_ABOUT_US_SECTION_NAME].hear_about_us,
      },
      hear_about_us: data[HEAR_ABOUT_US_SECTION_NAME].hear_about_us,
      seller_information: {
        country: data[COUNTRY_SECTION_NAME].country,
        document_number: data[VENDOR_FORM_SECTION_NAME].document_number.replace(
          cleanDocNumberRegex,
          ''
        ),
        email: data[VENDOR_FORM_SECTION_NAME].email,
        user_email: data[VENDOR_FORM_SECTION_NAME].repeat_email,
        lastname: data[VENDOR_FORM_SECTION_NAME].lastname,
        name: data[VENDOR_FORM_SECTION_NAME].name,
        phone: data[VENDOR_FORM_SECTION_NAME].phone
      },
      store_information: {
        dte_emit: data[SHOP_FORM_SECTION_NAME].dte_emit.toLowerCase(),
        business_name: data[SHOP_FORM_SECTION_NAME].business_name,
        commercial_name: data[SHOP_FORM_SECTION_NAME].commercial_name,
        id_social_reason: data[SHOP_FORM_SECTION_NAME].id_social_reason.replace(
          cleanDocNumberRegex,
          ''
        ),
      }
    }

    switch (state[COUNTRY_SECTION_NAME].country) {

      case CHILE.value:
        mappedData.store_information.economic_activity = data[SHOP_FORM_SECTION_NAME].economic_activity.map(
          (economicActivity) => economicActivity.code
        )
        break;

      case PERU.value:
        mappedData.about_store.asep = data[SHOP_FORM_SECTION_NAME].asep
        mappedData.about_store.own_fleet = data[SHOP_FORM_SECTION_NAME].own_fleet
        mappedData.about_store.quantity_products = data[SHOP_FORM_SECTION_NAME].quantity_products
        mappedData.about_store.other_marketplace = otherMarkets
        mappedData.store_information.store_address = {}
        mappedData.store_information.store_address.administrative_division_first = data[SHOP_FORM_SECTION_NAME].department
        mappedData.store_information.store_address.administrative_division_second = data[SHOP_FORM_SECTION_NAME].province
        break;
    
      default:
        break;
    }

    onPostRegistry(
      mappedData,
      token,
      dialogOnSuccess,
      handleSendError,
      dialogOnPending
    )
    .then(()=>{})
    .catch(()=>{})
  }

  const country = state[COUNTRY_SECTION_NAME].country
  const customValidationRules = validationRules.getAll(country)
  const customErrorMessages = errorMessages.getAll(country)
  
  const handleSetState = (key, sectionName) => (value) => {
    const newDataState = { ...state }
    const sectionRules = customValidationRules[sectionName]
    if (sectionRules === undefined || sectionRules === '') {
      newDataState[sectionName][key] = value
      setState(newDataState)
      return
    }
    const sectionFieldRules = sectionRules[key]
    if (sectionFieldRules === undefined || sectionFieldRules === '') {
      newDataState[sectionName][key] = value
      setState(newDataState)
      return
    }
    const newErrorsState = { ...errors }
    const emailValue = newDataState.vendorForm.email
    const validation = new Validator(
      { [key]: key === 'repeat_email' ? { value: value, comparison: emailValue } : value },
      { [key]: sectionFieldRules },
      customErrorMessages[sectionName]
    )
    if (validation.fails()) {
      newErrorsState[sectionName][key] = validation.errors.first(key)
    } else {
      newErrorsState[sectionName][key] = ''
    }
    onHandleErrors(newErrorsState)
    newDataState[sectionName][key] = value
    setState(newDataState)
  }

  useEffect(() => {
    const validator = new Validator(state, customValidationRules)

    const envType = process.env.REACT_APP_ENVIRONMENT_TYPE !== undefined ? process.env.REACT_APP_ENVIRONMENT_TYPE.toString() : ''

    if (validator.fails() || (!checkedCaptcha && envType !== 'qa' )) {
      setSendButtonEnabled(false)
      return
    }
    setSendButtonEnabled(true)
  }, [state, checkedCaptcha, customValidationRules])

  const onChangeCaptcha = async (token) => {
    if (!token) {
      setToken('')
      setCheckedCaptcha(false)
      return
    }
    setToken(token)
    setCheckedCaptcha(true)
  }

  const handleRestoreErrors = (sectionName, fieldName) => {
    const newErrors = { ...errors }
    newErrors[sectionName][fieldName] = ''
    onHandleErrors(newErrors)
  }

  const hearAboutUsStateProps = {
    state: state[HEAR_ABOUT_US_SECTION_NAME],
    setState,
    handleSetState,
    errors: errors[HEAR_ABOUT_US_SECTION_NAME],
    onRestoreErrors: handleRestoreErrors,
    country: country,
  }

  const otherMarketsStateProps = {
    state: state[OTHER_MARKETS_SECTION_NAME],
    setState,
    handleSetState,
    errors: errors[OTHER_MARKETS_SECTION_NAME],
    onRestoreErrors: handleRestoreErrors,
    country: country,
  }

  const vendorFormStateProps = {
    state: { ...state[VENDOR_FORM_SECTION_NAME], country },
    setState,
    handleSetState,
    errors: errors[VENDOR_FORM_SECTION_NAME],
    onRestoreErrors: handleRestoreErrors,
  }

  const shopFormStateProps = {
    state: { ...state[SHOP_FORM_SECTION_NAME], country },
    setState,
    handleSetState,
    errors: errors[SHOP_FORM_SECTION_NAME],
    onRestoreErrors: handleRestoreErrors,
  }
  
  return (
    <Grid container className={classes.root}>
      {DEPARTMENTS_WITH_OPL.includes(state[SHOP_FORM_SECTION_NAME].department) || state[SHOP_FORM_SECTION_NAME].department === '' ? (''):(
        <Grid container item className={classes.outlinedWarning}>
          <Alert icon={<Warning fontSize="inherit" />} variant="outlined" severity="warning" show={false}>
            {WARNING_DEPARTMENT}
          </Alert>
        </Grid>
      )}
      <Grid container item>
        <VendorForm
          stateProps={vendorFormStateProps}
          errors={errors[VENDOR_FORM_SECTION_NAME]}
          onRestoreErrors={handleRestoreErrors}
        />
      </Grid>
      <Grid item>
        <ShopForm
          stateProps={shopFormStateProps}
          errors={errors[SHOP_FORM_SECTION_NAME]}
          onRestoreErrors={handleRestoreErrors}
        />
      </Grid>
      {country === CHILE.value ? ('') : (
        <Grid container item>
          <MarketsForm stateProps={otherMarketsStateProps} />
        </Grid>
      )}
      <Grid container item>
        <AboutRegistry stateProps={hearAboutUsStateProps} />
      </Grid>
      {process.env.REACT_APP_ENVIRONMENT_TYPE === 'qa' ? ('') : (
        <Grid container item>
          <div className={classes.GridCaptcha}>
            <ReCAPTCHA 
              onChange={onChangeCaptcha}
              ref={recaptchaRef}
              sitekey={Settings.siteKey}
            />
          </div>
        </Grid>
      )}
      <Grid container item direction='row' justifyContent='center'>
        <Grid item xs={3} md={3} className={classes.sendButtonGrid}>
          <Button
            variant='contained'
            color='primary'
            onClick={onHandleSendData}
            fullWidth
            disabled={!sendButtonEnabled}
          >
            Enviar
          </Button>
        </Grid>
      </Grid>
      <ConfirmationDialog
        title={dialogState.title}
        type={dialogState.type}
        open={dialogState.open}
        maxWidth={dialogState.maxWidth}
        buttonLabels={{
          onCloseLabel: dialogState.buttonLabels.onCloseLabel,
          onSuccessLabel: dialogState.buttonLabels.onSuccessLabel
        }}
        actions={{
          onClose: dialogState.actions.onClose,
          onSuccess: dialogState.actions.onSuccess
        }}
        hasSecondaryButton={dialogState.hasSecondaryButton}
      >
        {dialogState.children}
      </ConfirmationDialog>
    </Grid>
  )
}

export default OnboardingDataForm
